export const apiConfig = {
  login: "/mobile/login",
  channelUserLogin: "/channel/user/login",
  sendOTP: "/mobile/send/otp",
  verifyOTP: "/mobile/otp/verify",
  dashboard: {
    dashboardData: "/garage/dashboard/v2",
  },
  customers: {
    getCustomers: "/garage/customers/v2",
    addCustomer: "/channel/user/coupon/generate",
  },
  garage: {
    fleet: "/garage/fleet",
    gameLevelConfigs: "/gameLevelConfigs",
    gameLevelConfigsUpdate: "/gameLevelConfigsUpdate",
  },
  team: {
    getTeamUsers: "/garage/team/users",
    addTeamMate: "/garage/team/user/add",
    getRoles: "/garage/team/user/roles",
  },
  user: "/user",
  mobileDeviceStatus: "/mobileDeviceStatus",
  vehicles: {
    alerts: "/alerts",
    vehicle: "/vehicle",
    vehicles: "/vehicles",
    userTrips: "/user/trip",
    trips: "/trips",
    drivingAlerts: "/vehicle/driving/alerts/v2",
    alertCustomers: "/garage/alerts/customers/v2",
    reminderCustomers: "/garage/customer/vehicle/reminders/v2",
    customerVehicles: "/garage/customer/vehicles",
    update: "/update",
    fuelExpenses: "/vehicle/fuel-expenses",
    fuelExpenseMetrics: "/vehicle/fuel-expense-metrics",
    fuelExpenseAdd: "/fuel-expense-add",
  },
  referrals: "/referrals",
  businessProfile: "/business/profile/add-update",
  orderCommissions: "/order/commission",
  accountDetails: "/wWGS4eqSDtUi",
  accountDetailsAddUpdate: "/bank/details/add/update",
  trip: {
    trip: "/trip",
    locationDetails: "/location/details",
  },
  drivingAnalytics: "/driving/analytics",
  tokenUpdate: "/fcmtoken/update",
  riskAnalysis: "/risk/analysis",
  drivingAlertsAnalysis: "/driving/alerts/analysis",
};
